import { StyleSheet } from 'react-native';

export const UnvalidatedStyles = {
  defaultProgressBarColor: 'rgba(0, 0, 0, 0.5)',
  defaultProgressBarUnfilledColor: 'rgba(0, 0, 0, 0.2)',
  circularProgressBarSize: {
    normal: 40,
    small: 24,
  },
};

export const Styles = StyleSheet.create({
  circularProgressBarNormalSize: {
    width: UnvalidatedStyles.circularProgressBarSize.normal,
    height: UnvalidatedStyles.circularProgressBarSize.normal,
  },
  circularProgressBarSmallSize: {
    width: UnvalidatedStyles.circularProgressBarSize.small,
    height: UnvalidatedStyles.circularProgressBarSize.small,
  },
});
